import { Component, OnInit, ViewChild } from '@angular/core'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AddChildContactInfoComponent } from '@se-po/shared-ui-add-child-contact-info'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { UserServiceResources as us } from 'se-resource-types'

import { ChildContactInfoSubmitter } from './child-contact-info-submit.service'

/**
 * @deprecated This component has been deprecated and removed from the
 * household setup flow for the time being.
 * @todo Revisit this and remove or reimplement.
 */
@Component({
  selector: 'se-po-household-setup-feature-child-contact-info',
  templateUrl: './child-contact-info.component.html',
  styleUrls: ['./child-contact-info.component.scss'],
})
export class ChildContactInfoComponent implements OnInit {
  @ViewChild('childContactInfo') public childContactInfo: AddChildContactInfoComponent
  public persona: us.Persona
  public ready = false
  public description: string

  constructor(
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: ChildContactInfoSubmitter,
  ) { }

  public ngOnInit(): void {
    this.persona = this.store.childPersona
    if (!this.persona) return this.submitter.reset(this.store)

    this.description = 'Only add a phone or email if you’d ' +
      'like ' + this.persona.first_name + ' to receive their own messages. ' +
      'Your contact information will be collected on the next step.'
    this.ready = true
    this.setupBarService.percentComplete = 20
  }

  public submit(): void {
    this.submitter.submit(this.childContactInfo.value, this.store)
  }
}
